import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, PayrollProvider, useAuth } from '@/context/AppContext';
import { ToastProvider } from '@/hooks/useToast';
import { AuthScreen } from '@/components/layout/AuthScreen';
import { AppLayout } from '@/components/layout/AppLayout';
import { UploadPage } from '@/pages/UploadPage';
import { PeriodPage } from '@/pages/PeriodPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { ReviewPage } from '@/pages/ReviewPage';
import { AttendancePage } from '@/pages/AttendancePage';
import { ResultsPage } from '@/pages/ResultsPage';
import { PrintPage } from '@/pages/PrintPage';
import { ExportPage } from '@/pages/ExportPage';
import { Loader2 } from 'lucide-react';

function Gate() {
  const { user, booting } = useAuth();

  if (booting) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 to-violet-50 dark:from-slate-950 dark:to-slate-900">
        <div className="text-center animate-fade-in">
          <div className="inline-flex w-16 h-16 rounded-2xl gradient-primary items-center justify-center shadow-xl mb-4">
            <Loader2 size={32} className="text-white animate-spin" />
          </div>
          <p className="text-slate-600 dark:text-slate-300 font-semibold">جاري التحميل...</p>
        </div>
      </div>
    );
  }

  if (!user) return <AuthScreen />;

  return (
    <PayrollProvider user={user}>
      {/* Print root - rendered at top level (outside main layout) so the @media print rule works correctly */}
      <div id="print-root" className="print-only" />
      <AppLayout>
        <Routes>
          <Route path="/" element={<Navigate to="/upload" replace />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/period" element={<PeriodPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/review" element={<ReviewPage />} />
          <Route path="/attendance" element={<Navigate to="/review" replace />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/print" element={<PrintPage />} />
          <Route path="/export" element={<ExportPage />} />
          <Route path="*" element={<Navigate to="/upload" replace />} />
        </Routes>
      </AppLayout>
    </PayrollProvider>
  );
}

export default function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <AuthProvider>
          <Gate />
        </AuthProvider>
      </BrowserRouter>
    </ToastProvider>
  );
}
